import { withQueryClientContext } from '../../../../../app/shared/components/QueryClientContext'
import { useNewsRefresh } from '../../hooks/useNewsRefresh'

interface NewsRefreshProps {
  ticker: string
}

/**
 * Component that handles automatic news refresh for quote page
 * Renders nothing, just manages the refresh logic
 */
function NewsRefreshComponent({ ticker }: NewsRefreshProps) {
  useNewsRefresh({ ticker })

  // This component doesn't render anything visible
  // It just runs the refresh logic in the background
  return null
}

export const NewsRefresh = withQueryClientContext(NewsRefreshComponent)
